import { render, staticRenderFns } from "./DeliveryCodesDetails.vue?vue&type=template&id=837b146a&"
import script from "./DeliveryCodesDetails.vue?vue&type=script&lang=ts&"
export * from "./DeliveryCodesDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports